import React from "react";
import { ErrorBoundary } from "./components/ErrorBoundary";
import KQuantSmartInsightsPage from "./pages/KQuantSmartInsightsPage/KQuantSmartInsightsPage";

export default function App() {
  return (
    <ErrorBoundary>
      <KQuantSmartInsightsPage />
    </ErrorBoundary>
  );
}
